export const iconFontAwesomeUsersPeoplePeopleRobbery = (
	<i className="fa-solid fa-people-robbery"></i>
);
